import { EntityFunctionalTypeEnum } from "gen/model/entityFunctionalTypeEnum";

export const FUND_ENTITY_FUNCTIONAL_TYPES = [
  EntityFunctionalTypeEnum.main_fund,
  EntityFunctionalTypeEnum.parallel_fund,
  EntityFunctionalTypeEnum.master_fund,
  EntityFunctionalTypeEnum.feeder_fund,
  EntityFunctionalTypeEnum.coinvestment_vehicle,
  EntityFunctionalTypeEnum.joint_venture,
  EntityFunctionalTypeEnum.blocker,
  EntityFunctionalTypeEnum.aggregator,
];
